import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.incident-meldung-erfassen';
import * as api from '../../../clients/incidents';

@Injectable()
export class IncidentsIncidentMeldungErfassenEffects {

    IncidentMeldungErfassen$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_INCIDENT_MELDUNG_ERFASSEN),
        mergeMap((x: ac.PostIncidentMeldungErfassenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postIncidentMeldungErfassen(x.incidentMeldungRequest).pipe(
                map((result: any) => {
                    return new ac.PostIncidentMeldungErfassenErfolgreichAction(result, x.incidentMeldungRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostIncidentMeldungErfassenFehlerAction(error, x.incidentMeldungRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.IncidentsCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.IncidentsCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.IncidentsCommandService);
        }
        return this.service;
    }
}
